import { FC } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { PPVGeneral } from "../../types";

const Card = styled.div`
  position: relative;
  aspect-ratio: 2 / 3;
  border-radius: 10px;
  overflow: hidden;
  cursor: pointer;
  border: 1px solid rgba(163, 27, 27, 0.35);
  transition: transform 0.22s ease, box-shadow 0.22s ease, border-color 0.22s ease;

  &:hover {
    transform: translateY(-5px);
    border-color: rgba(163, 27, 27, 0.7);
    box-shadow: 0 10px 32px rgba(163, 27, 27, 0.2), 0 4px 14px rgba(0, 0, 0, 0.5);
  }

  &:hover img {
    transform: scale(1.06);
  }

  &:hover .overlay {
    opacity: 1;
  }
`;

const Poster = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  transition: transform 0.35s ease;
`;

const BottomGradient = styled.div`
  position: absolute;
  inset: 0;
  background: linear-gradient(
    to top,
    rgba(0, 0, 0, 0.88) 0%,
    rgba(0, 0, 0, 0.3) 45%,
    transparent 70%
  );
`;

const HoverOverlay = styled.div`
  position: absolute;
  inset: 0;
  background: linear-gradient(
    to top,
    rgba(163, 27, 27, 0.28) 0%,
    transparent 60%
  );
  opacity: 0;
  transition: opacity 0.25s ease;
`;

const BottomInfo = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 12px 12px 14px;
`;

const PpvName = styled.p`
  margin: 0;
  color: #fff;
  font-weight: 700;
  font-size: 14px;
  letter-spacing: 0.3px;
  line-height: 1.3;
  text-shadow: 0 1px 4px rgba(0, 0, 0, 0.8);
`;

const EditionsBadge = styled.span`
  display: inline-block;
  margin-top: 5px;
  font-size: 11px;
  color: rgba(255, 255, 255, 0.6);
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 4px;
  padding: 1px 7px;
`;

interface SingleCardPpvProps {
  ppv: PPVGeneral;
  id?: string;
  namePpv?: string;
}

const SingleCardPpv: FC<SingleCardPpvProps> = ({ ppv, id }) => {
  const navigate = useNavigate();

  return (
    <Card id={id} onClick={() => navigate(`/ppv/i_${ppv.id}_d_${ppv.name}`)}>
      <Poster
        src={process.env.REACT_APP_STORAGE_URL + ppv.img_path}
        alt={ppv.name}
      />
      <BottomGradient />
      <HoverOverlay className="overlay" />
      <BottomInfo>
        <PpvName>{ppv.name}</PpvName>
        {!!ppv.ppvs?.length && (
          <EditionsBadge>
            {ppv.ppvs.length} {ppv.ppvs.length === 1 ? 'edizione' : 'edizioni'}
          </EditionsBadge>
        )}
      </BottomInfo>
    </Card>
  );
};

export default SingleCardPpv;
